import {pipe} from 'ramda'
import ImageSlider from './modules/image-slider';

pipe(
    ImageSlider,
)();



// WEBPACK FOOTER //
// ../src/scripts/image-slider.js